import { useMemo } from 'react'
import { useQuery } from '@apollo/client'
import { GET_ORGANIZER_ROLES } from '../graphql/query/getOrganizerRoles'

const FINANCES_CATEGORY = 'Finances'

export const useHasFinancesAccess = () => {
  const { data } = useQuery(GET_ORGANIZER_ROLES, {
    fetchPolicy: 'cache-first',
  })

  return useMemo(() => {
    if (!data) return false

    const currentUserRoles = data.currentUser?.roles || []
    const roleFrame = data.currentUser?.organizer?.listRoles || {}
    const financesRoles = roleFrame[FINANCES_CATEGORY]

    if (!financesRoles) return false

    return financesRoles.some((role) => currentUserRoles.includes(role.id))
  }, [data])
}
